fabric.LineTwoArrow = fabric.util.createClass(fabric.Line, {
	type: "lineTwoArrow",

	initialize: function (element, options) {
		options || (options = {});
		this.callSuper("initialize", element, options);
	},

	toObject: function () {
		return fabric.util.object.extend(this.callSuper("toObject"));
	},

	_render: function (ctx) {
		this.callSuper("_render", ctx);

		const xDiff = this.x2 - this.x1;
		const yDiff = this.y2 - this.y1;


		//this might be usefull to fix rendering problems with strokeWidht > 50
		//coordinates start (x=0, y=0) at left top corner 
		// if (xDiff > this.strokeWidth && yDiff > this.strokeWidth)
		// 	if (this.x1 < this.x1 && this.y1 < this.y1) {
		// 		this.x1 = this.x1 + (this.strokeWidth / 2);
		// 		this.x2 = this.x2 - (this.strokeWidth / 2);

		// 		this.y1 = this.y1 + (this.strokeWidth / 2);
		// 		this.y2 = this.y2 - (this.strokeWidth / 2);
		// 	} else {
		// 		this.x1 = this.x1 - (this.strokeWidth / 2);
		// 		this.x2 = this.x2 + (this.strokeWidth / 2);

		// 		this.y1 = this.y1 - (this.strokeWidth / 2);
		// 		this.y2 = this.y2 + (this.strokeWidth / 2);
		// 	}


		const mod = n => {
			return n ? ((this % n) + n) % n : 0;
		};

		// do not render if diff between X or Y less than stroke with or object is not visible
		if (
			(mod(xDiff) < this.strokeWidth && mod(yDiff) < this.strokeWidth) ||
            !this.visible
		)
			return;

		const angle = Math.atan2(yDiff, xDiff);
		const angle2 = angle > 0 ? angle - Math.PI : angle + Math.PI;
		const x = xDiff / 2;
		const y = yDiff / 2;

		this.__drawArrowHead(ctx, x, y, angle);
		this.__drawArrowHead(ctx, -x, -y, angle2);
	},

	__drawArrowHead: function (ctx, x, y, angle) {
		ctx.save();
		ctx.beginPath();
		ctx.translate(x, y);
		ctx.rotate(angle);
		//move 10px in front of line to start the arrow so it does not have the square line end showing in front (0,0)
		ctx.moveTo(1 * this.strokeWidth, 0);
		ctx.lineTo(-1 * (3 * this.strokeWidth), 2 * this.strokeWidth);
		ctx.lineTo(-1 * (3 * this.strokeWidth), -1 * (2 * this.strokeWidth));
		ctx.closePath();
		ctx.restore();
		ctx.fillStyle = this.stroke;
		ctx.fill();
	}
});

fabric.LineTwoArrow.fromObject = function (object, callback) {
	callback &&
        callback(
        	new fabric.LineTwoArrow(
        		[object.x1, object.y1, object.x2, object.y2],
        		object
        	)
        );
};

fabric.LineTwoArrow.async = true;
